export default (t) => new Promise(resolve => setTimeout(resolve, t));
//# sourceMappingURL=sleep.mjs.map